<template>
  <div>
    <article class="con-wrapper-mt container">
      <div class="con1">
        <div class="con1-1">
          <p>글로벌 역량 강화</p>
          <p>
            글로벌 역량 강화를 위한<br />최상의 프로그램과 토탈 솔루션을
            제공합니다.
          </p>
          <a class="pointer" @click="openPage('/Global')">more</a>
        </div>
        <ul class="con1-2">
          <li class="pointer" @click="openPage('/Global#content01')">
            <a>In-House Language Training</a>
          </li>
          <li class="pointer" @click="openPage('/Global#content02')">
            <a>1:1 Co-Active Learning</a>
          </li>
          <li class="pointer" @click="openPage('/Global#content04')">
            <a>글로벌 비즈니스 스킬 워크샵</a>
          </li>
          <li class="pointer" @click="openPage('/Nurture#content02')">
            <a>해외법인 글로컬라이제이션 교육</a>
          </li>
          <li class="pointer" @click="openPage('/Global#content05')">
            <a>Global Expert Program</a>
          </li>
          <li class="pointer" @click="openPage('/Nurture#content03')">
            <a>지역전문가 양성과정</a>
          </li>
          <li class="pointer" @click="openPage('/Global#content07')">
            <a>기적의 7일 코스</a>
          </li>
          <li class="pointer" @click="openPage('/Global#content09')">
            <a>의료보건산업 글로벌 인력양성과정</a>
          </li>
          <li class="pointer" @click="openPage('/Global#content08')">
            <a>항공 및 방산 회화 과정</a>
          </li>
        </ul>
      </div>
      <ul class="con2">
        <li>
          <div>
            <p>이문화 역량 강화 솔루션</p>
            <p>
              성공적인 해외 비즈니스를 위한<br />
              해외 주재원, 지역전문가, 글로벌 비즈니스 전문가는<br />
              이문화 역량에서 시작해야 합니다.
            </p>
          </div>
          <a class="pointer" @click="openPage('/CrossCulture#content01')"
            >more</a
          >
        </li>
        <li>
          <div>
            <p>디지털 역량 강화</p>
            <p>
              4차 산업혁명 이후 비즈니스 성공을 위해<br />
              반드시 필요한 디지털 문해력을 높이고<br />
              데이터 기반 고객 경험과 직원 경험을<br />
              혁신하는 코스를 운영합니다.
            </p>
          </div>
          <a class="pointer" @click="openPage('/Digital')">more</a>
        </li>
        <li>
          <div>
            <p>글로벌 역량진단(gCAT)</p>
            <p>
              해외 주재원 선발의<br />
              기준을 제시하고<br />
              맞춤 훈련 프로그램을 제안합니다.
            </p>
          </div>
          <a class="pointer" @click="openPage('/Consulting#content01')">more</a>
        </li>
        <li>
          <div>
            <p>1:1 Language Lab</p>
            <p>
              하루 20~30분!<br />
              1:1 집중 Clinic을 통한<br />
              개인별 맞춤 코칭 과정을 추천합니다.
            </p>
          </div>
          <a class="pointer" @click="openPage('/Global#content03')">more</a>
        </li>
      </ul>
      <div class="con3">
        <div class="con3-1">
          <p>주재원 통합 솔루션</p>
          <p>
            해외 주재원 및 장기 파견자에게<br />성공적인 업무 수행, 현지 정착,
            귀임까지<br />통합된 솔루션을 제공합니다.
          </p>
          <a class="pointer" @click="openPage('/Nurture')">more</a>
        </div>
        <div class="con3-2">
          <div class="con3-2-1">
            <p>리더십 솔루션</p>
            <p>
              글로벌 비즈니스 환경에서 요구되는<br />리더십, 조직활성화, 코칭
              솔루션을<br />제공합니다.
            </p>
            <a class="pointer" @click="openPage('/Leadership')">more</a>
          </div>
          <ul class="con3-2-2">
            <li class="pointer" @click="openPage('/Leadership#content01')">
              <a>
                <p>CCL Lead 4 Success 리더십</p>
                <p>
                  세계 최고의 리더십 기관 CCL과 캐럿이 함께 하는 리더십 프로그램
                </p>
              </a>
            </li>
            <li class="pointer" @click="openPage('/Leadership#content02')">
              <a>
                <p>문제해결리더십(PBL) : 리더십 딜레마</p>
                <p>
                  현장의 문제를 중심으로 케이스 기반의 문제해결 워크숍 프로그램
                </p>
              </a>
            </li>
            <li class="pointer" @click="openPage('/Leadership#content03')">
              <a>
                <p>플립 리더십 코칭 프로그램</p>
                <p>24개 온라인 모듈 X 오프라인 코칭 프로그램</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <ul class="con4">
        <li>
          <p>맞춤형 해외연수</p>
          <p>
            해외 혁신 기업 탐방 및 맞춤 연수를 통해<br />기업의 위협 상황을
            성장과 혁신의 기회로<br />전환할 수 있게 도와드립니다.
          </p>
          <a class="pointer" @click="openPage('/Customized')">more</a>
        </li>
        <li>
          <p>SPAC^ 말하기 평가센터</p>
          <p>
            가장 빠르고 신뢰도 높은 말하기 평가! <br />최적의 어학 평가 솔루션
            SPAC^을 만나보세요!
          </p>
          <ul>
            <li
              class="pointer"
              @click="openPage('http://www.thespac.net/new/')"
            >
              <div class="bullet"></div>
              <a>SPAC^ (영어/중국어/일본어/스페인어/베트남어/한국어)</a>
            </li>
          </ul>
          <a class="pointer" @click="openPage('http://www.thespac.net/new/')"
            >more</a
          >
        </li>
      </ul>
    </article>

    <!-- con-wrapper-pc -->
    <article class="con-wrapper-pc container">
      <div class="top-con">
        <div class="con1">
          <div class="con1-1">
            <p>글로벌 역량 강화</p>
            <p>
              글로벌 역량 강화를 위한<br />최상의 프로그램과 토탈 솔루션을
              제공합니다.
            </p>
            <a class="pointer" @click="openPage('/Global')">more</a>
          </div>
          <ul class="con1-2">
            <li class="pointer" @click="openPage('/Global#content01')">
              <a>In-House Language Training</a>
            </li>
            <li class="pointer" @click="openPage('/Global#content02')">
              <a>1:1 Co-Active Learning</a>
            </li>
            <li class="pointer" @click="openPage('/Global#content04')">
              <a>글로벌 비즈니스 스킬 워크샵</a>
            </li>
            <li class="pointer" @click="openPage('/Nurture#content02')">
              <a>해외법인 글로컬라이제이션 교육</a>
            </li>
            <li class="pointer" @click="openPage('/Global#content05')">
              <a>Global Expert Program</a>
            </li>
            <li class="pointer" @click="openPage('/Nurture#content03')">
              <a>지역전문가 양성과정</a>
            </li>
            <li class="pointer" @click="openPage('/Global#content07')">
              <a>기적의 7일 코스</a>
            </li>
            <li class="pointer" @click="openPage('/Global#content09')">
              <a>의료보건산업 글로벌 인력양성과정</a>
            </li>
            <li class="pointer" @click="openPage('/Global#content08')">
              <a>항공 및 방산 회화 과정</a>
            </li>
          </ul>
        </div>
        <div class="con3">
          <div class="con3-1">
            <p>주재원 통합 솔루션</p>
            <p>
              해외 주재원 및 장기 파견자에게<br />성공적인 업무 수행, 현지 정착,
              귀임까지<br />통합된 솔루션을 제공합니다.
            </p>
            <a class="pointer" @click="openPage('/Nurture')">more</a>
          </div>
          <div class="con3-2">
            <div class="con3-2-1">
              <p>리더십 솔루션</p>
              <p>
                글로벌 비즈니스 환경에서 요구되는<br />리더십, 조직활성화, 코칭
                솔루션을<br />제공합니다.
              </p>
              <a class="pointer" @click="openPage('/Leadership')">more</a>
            </div>
            <ul class="con3-2-2">
              <li class="pointer" @click="openPage('/Leadership#content01')">
                <a>
                  <p>CCL Lead 4 Success 리더십</p>
                  <p>
                    세계 최고의 리더십 기관 CCL과 캐럿이 함께 하는 리더십
                    프로그램
                  </p>
                </a>
              </li>
              <li class="pointer" @click="openPage('/Leadership#content02')">
                <a>
                  <p>문제해결리더십(PBL) : 리더십 딜레마</p>
                  <p>
                    현장의 문제를 중심으로 케이스 기반의 문제해결 워크숍
                    프로그램
                  </p>
                </a>
              </li>
              <li class="pointer" @click="openPage('/Leadership#content03')">
                <a>
                  <p>플립 리더십 코칭 프로그램</p>
                  <p>24개 온라인 모듈 X 오프라인 코칭 프로그램</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="bottom-con">
        <ul class="con2">
          <li>
            <div>
              <p>이문화 역량 강화 솔루션</p>
              <p>
                성공적인 해외 비즈니스를 위한<br />
                해외 주재원, 지역전문가, 글로벌 비즈니스 전문가는<br />
                이문화 역량에서 시작해야 합니다.
              </p>
            </div>
            <a class="pointer" @click="openPage('/CrossCulture#content01')"
              >more</a
            >
          </li>
          <li>
            <div>
              <p>디지털 역량 강화</p>
              <p>
                4차 산업혁명 이후 비즈니스 성공을 위해<br />
                반드시 필요한 디지털 문해력을 높이고<br />
                데이터 기반 고객 경험과 직원 경험을<br />
                혁신하는 코스를 운영합니다.
              </p>
            </div>
            <a class="pointer" @click="openPage('/Digital')">more</a>
          </li>
          <li>
            <div>
              <p>글로벌 역량진단(gCAT)</p>
              <p>
                해외 주재원 선발의<br />
                기준을 제시하고<br />
                맞춤 훈련 프로그램을 제안합니다.
              </p>
            </div>
            <a class="pointer" @click="openPage('/Consulting#content01')"
              >more</a
            >
          </li>
          <li>
            <div>
              <p>1:1 Language Lab</p>
              <p>
                하루 20~30분!<br />
                1:1 집중 Clinic을 통한<br />
                개인별 맞춤 코칭 과정을 추천합니다.
              </p>
            </div>
            <a class="pointer" @click="openPage('/Global#content03')">more</a>
          </li>
        </ul>
        <ul class="con4">
          <li>
            <p>맞춤형 해외연수</p>
            <p>
              해외 혁신 기업 탐방 및 맞춤 연수를 통해<br />기업의 위협 상황을
              성장과 혁신의 기회로<br />전환할 수 있게 도와드립니다.
            </p>
            <a class="pointer" @click="openPage('/Customized')">more</a>
          </li>
          <li>
            <p>SPAC^ 말하기 평가센터</p>
            <p>
              가장 빠르고 신뢰도 높은 말하기 평가! <br />최적의 어학 평가 솔루션
              SPAC^을 만나보세요!
            </p>
            <ul>
              <li
                class="pointer"
                @click="openPage('http://www.thespac.net/new/')"
              >
                <div class="bullet"></div>
                <a>SPAC^ (영어/중국어/일본어/스페인어/베트남어/한국어)</a>
              </li>
            </ul>
            <a class="pointer" @click="openPage('http://www.thespac.net/new/')"
              >more</a
            >
          </li>
        </ul>
      </div>
    </article>
  </div>
</template>
<script>
export default {
  methods: {
    openPage(path) {
      window.open(path, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.con-wrapper-pc {
  display: none;
}

// con-wrapper-mt
.con-wrapper-mt {
  padding: 40px 0;

  .con1 {
    margin-bottom: 20px;

    .con1-1 {
      padding: 30px 20px;
      background: url(~@/assets/img/newGlobal/main/content/con1-bg1.png)
        no-repeat center / cover;
      color: #ffffff;

      p:nth-child(1) {
        font-size: 30px;
        font-weight: 700;
        margin-bottom: 12px;
      }

      p:nth-child(2) {
        font-size: 14px;
        margin-bottom: 24px;
      }

      a {
        display: inline-block;
        font-size: 13px;
        color: #ffffff;
      }
    }

    .con1-2 {
      padding: 20px;
      background-color: #f3f3f3;

      li {
        padding-bottom: 14px;
        border-bottom: 1px solid #ebebeb;
        margin-bottom: 14px;

        &:last-child {
          padding-bottom: 0;
          border-bottom: 0 none;
          margin-bottom: 0;
        }

        a {
          font-size: 15px;
          color: #282c32;
        }
      }
    }
  }

  .con2 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin-bottom: 20px;

    li {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 30px 0;
      padding: 20px;

      &:nth-child(1) {
        background: #f4f4f4
          url(~@/assets/img/newGlobal/main/content/con1-bg2.png) no-repeat right
          bottom / contain;
      }

      &:nth-child(2) {
        background: #f4f4f4
          url(~@/assets/img/newGlobal/main/content/con1-bg3.png) no-repeat right
          bottom / contain;
      }

      &:nth-child(3) {
        background: #f4f4f4
          url(~@/assets/img/newGlobal/main/content/con1-bg4.png) no-repeat right
          bottom / contain;
      }

      &:nth-child(4) {
        background: #f4f4f4
          url(~@/assets/img/newGlobal/main/content/con1-bg5.png) no-repeat right
          bottom / contain;
      }

      p:nth-child(1) {
        font-size: 17px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      p:nth-child(2) {
        font-size: 15px;
      }

      a {
        display: inline-block;
        font-size: 13px;
        color: #232323;
      }
    }
  }

  .con3 {
    margin-bottom: 20px;

    .con3-1 {
      padding: 30px 20px;
      background: url(~@/assets/img/newGlobal/main/content/con1-bg6.png)
        no-repeat center / cover;
      color: #ffffff;
      margin-bottom: 20px;

      p:nth-child(1) {
        font-size: 30px;
        font-weight: 700;
        margin-bottom: 12px;
      }

      p:nth-child(2) {
        font-size: 14px;
        margin-bottom: 24px;
      }

      a {
        display: inline-block;
        font-size: 13px;
        color: #ffffff;
      }
    }

    .con3-2 {
      .con3-2-1 {
        padding: 30px 20px;
        background: url(~@/assets/img/newGlobal/main/content/con1-bg7.png)
          no-repeat center / cover;
        color: #ffffff;

        p:nth-child(1) {
          font-size: 30px;
          font-weight: 700;
          margin-bottom: 12px;
        }

        p:nth-child(2) {
          font-size: 14px;
          margin-bottom: 24px;
        }

        a {
          display: inline-block;
          font-size: 13px;
          color: #ffffff;
        }
      }

      .con3-2-2 {
        padding: 20px;
        background-color: #f3f3f3;

        li {
          margin-bottom: 16px;

          &:last-child {
            margin-bottom: 0;
          }

          p:nth-child(1) {
            font-size: 13px;
            color: #f66826;
            margin-bottom: 6px;
          }

          p:nth-child(2) {
            font-size: 13px;
            color: #232b2c;
          }
        }
      }
    }
  }

  .con4 {
    > li {
      padding: 30px 20px;
      color: #ffffff;

      &:nth-child(1) {
        background: url(~@/assets/img/newGlobal/main/content/con1-bg8.png)
          no-repeat center / cover;
        margin-bottom: 20px;
      }

      &:nth-child(2) {
        background: url(~@/assets/img/newGlobal/main/content/con1-bg9.png)
          no-repeat center / cover;

        > a {
          margin-top: 30px;
        }

        ul {
          li {
            display: flex;
            align-items: center;
            gap: 0 10px;

            &:nth-child(1) {
              margin-bottom: 5px;
            }

            .bullet {
              width: 3px;
              height: 3px;
              background: url(~@/assets/img/newGlobal/main/content/bullet.png)
                no-repeat center / cover;
            }

            a {
              font-weight: bold;
            }
          }
        }
      }

      p:nth-child(1) {
        font-size: 30px;
        font-weight: 700;
        margin-bottom: 12px;

        span {
          font-size: 13px;
        }
      }

      p:nth-child(2) {
        font-size: 14px;
        margin-bottom: 24px;
      }

      a {
        display: inline-block;
        font-size: 13px;
        color: #ffffff;
      }
    }
  }
}

// con-wrapper-pc
.con-wrapper-pc {
  padding: 80px 0;

  .top-con {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
  }

  .bottom-con {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 20px;
  }

  .con1 {
    width: 384px;

    .con1-1 {
      padding: 30px 20px;
      background: url(~@/assets/img/newGlobal/main/content/con1-bg1.png)
        no-repeat center / cover;
      color: #ffffff;

      p:nth-child(1) {
        font-size: 30px;
        font-weight: 700;
        margin-bottom: 12px;
      }

      p:nth-child(2) {
        font-size: 17px;
        margin-bottom: 24px;
      }

      a {
        display: inline-block;
        font-size: 13px;
        color: #ffffff;
      }
    }

    .con1-2 {
      padding: 20px;
      background-color: #f3f3f3;

      li {
        padding-bottom: 14px;
        border-bottom: 1px solid #ebebeb;
        margin-bottom: 14px;

        &:last-child {
          padding-bottom: 0;
          border-bottom: 0 none;
          margin-bottom: 0;
        }

        a {
          font-size: 15px;
          color: #282c32;
        }
      }
    }
  }

  .con2 {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    li {
      flex-grow: 1;
      width: 48%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 20px;

      &:nth-child(1) {
        height: 240px;
        background: #f4f4f4
          url(~@/assets/img/newGlobal/main/content/con1-bg2.png) no-repeat right
          bottom / 300px;
      }

      &:nth-child(2) {
        height: 240px;
        background: #f4f4f4
          url(~@/assets/img/newGlobal/main/content/con1-bg3.png) no-repeat right
          bottom / 300px;
      }

      &:nth-child(3) {
        height: 284px;
        background: #f4f4f4
          url(~@/assets/img/newGlobal/main/content/con1-bg4.png) no-repeat right
          bottom / contain;
      }

      &:nth-child(4) {
        height: 284px;
        background: #f4f4f4
          url(~@/assets/img/newGlobal/main/content/con1-bg5.png) no-repeat right
          bottom / contain;
      }

      p:nth-child(1) {
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      p:nth-child(2) {
        font-size: 15px;
      }

      a {
        display: inline-block;
        font-size: 13px;
        color: #232323;
      }
    }
  }

  .con3 {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    .con3-1 {
      flex-grow: 1;
      padding: 30px 20px;
      background: url(~@/assets/img/newGlobal/main/content/con1-bg6.png)
        no-repeat center / cover;
      color: #ffffff;
      margin-bottom: 20px;

      p:nth-child(1) {
        font-size: 30px;
        font-weight: 700;
        margin-bottom: 12px;
      }

      p:nth-child(2) {
        font-size: 17px;
        margin-bottom: 24px;
      }

      a {
        display: inline-block;
        font-size: 13px;
        color: #ffffff;
      }
    }

    .con3-2 {
      display: flex;

      .con3-2-1 {
        flex-grow: 1;
        padding: 30px 20px;
        background: url(~@/assets/img/newGlobal/main/content/con1-bg7.png)
          no-repeat center / cover;
        color: #ffffff;

        p:nth-child(1) {
          font-size: 30px;
          font-weight: 700;
          margin-bottom: 12px;
        }

        p:nth-child(2) {
          font-size: 17px;
          margin-bottom: 24px;
        }

        a {
          display: inline-block;
          font-size: 13px;
          color: #ffffff;
        }
      }

      .con3-2-2 {
        flex-grow: 1;
        padding: 20px;
        background-color: #f3f3f3;

        li {
          margin-bottom: 16px;

          &:last-child {
            margin-bottom: 0;
          }

          p:nth-child(1) {
            font-size: 15px;
            color: #f66826;
            margin-bottom: 6px;
          }

          p:nth-child(2) {
            font-size: 15px;
            color: #232b2c;
          }
        }
      }
    }
  }

  .con4 {
    > li {
      padding: 30px 20px;
      color: #ffffff;

      &:nth-child(1) {
        background: url(~@/assets/img/newGlobal/main/content/con1-bg8.png)
          no-repeat center / cover;
        margin-bottom: 20px;
      }

      &:nth-child(2) {
        background: url(~@/assets/img/newGlobal/main/content/con1-bg9.png)
          no-repeat center / cover;
        height: 100%;
        max-height: 284px;

        > a {
          margin-top: 30px;
        }

        ul {
          li {
            display: flex;
            align-items: center;
            gap: 0 10px;

            &:nth-child(1) {
              margin-bottom: 5px;
            }

            .bullet {
              width: 3px;
              height: 3px;
              background: url(~@/assets/img/newGlobal/main/content/bullet.png)
                no-repeat center / cover;
            }

            a {
              font-weight: bold;
            }
          }
        }
      }

      p:nth-child(1) {
        font-size: 30px;
        font-weight: 700;
        margin-bottom: 12px;

        span {
          font-size: 13px;
        }
      }

      p:nth-child(2) {
        font-size: 17px;
        margin-bottom: 24px;
      }

      a {
        display: inline-block;
        font-size: 13px;
        color: #ffffff;
      }
    }
  }
}

@media screen and (min-width: 1350px) {
  .con-wrapper-mt {
    display: none;
  }

  .con-wrapper-pc {
    display: block;
  }
}
</style>
